@if (isLoadingWithDelay$ | async;) {
  <div>
    <mat-progress-bar mode="indeterminate"
      [style.width]="width + '%'"
    style="position:absolute;"></mat-progress-bar>
  </div>
}
